import React from 'react';
import { TableBodyCell, TableBodyRow, TableHeadRow } from '@trackman/web-shared-components';
import styled from 'styled-components';
import { filtersBackground, white } from '../../../styles/Colors';

export const StyledRow = styled.div<{ disabled: boolean }>`
  ${(props) => (props.disabled ? 'opacity: 0.5;' : '')}
`;

export const StyledTableBodyRow = styled((props) => <TableBodyRow {...props} />)`
  padding: 0 24px;
`;

export const StyledTableBodyCell = styled((props) => <TableBodyCell {...props} />)`
  font-weight: 400;
`;

export const StyledNoData = styled.div`
  padding: 75px 0 80px;
  background-color: ${white};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  color: var(--Grayscale-tertiaryGrey, #717171);
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;

export const StyledTableHeadRow = styled((props) => <TableHeadRow {...props} />)`
  height: 56px !important;
  padding: 0 24px;
  
  th {
    font-size: 15px;
  }
`;

export const StyledFilters = styled.div`
  background-color: ${filtersBackground};
  border-radius: 5px 5px 0 0;
  font-size: 15px;
`;
